import { ChangeEvent, useEffect, useState } from "react"

import { css, cx } from "@emotion/css"
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core"
import { useI18n } from "providers/I18n"
import { MbaConfiguration } from "models/mba"

type Props = {
  data?: MbaConfiguration
  update: (
    variables: Partial<MbaConfiguration & { clientConfig?: string }>,
  ) => Promise<Partial<MbaConfiguration>> | void
  id?: string
  disabled?: boolean
  configScope?: "CAMPAIGN" | "CLIENT_AGENCY"
}

export const ExportTvView = (props: Props) => {
  const { t } = useI18n()
  const { data, update, id, disabled, configScope } = props
  const [tvSheetView, setTvSheetView] = useState(data?.isSpot)

  useEffect(() => {
    setTvSheetView(data?.isSpot)
  }, [data?.isSpot])

  const handleTvViewSelection = (
    evt: ChangeEvent<
      | HTMLInputElement
      | {
          name?: string | undefined
          value: unknown
        }
    >,
  ) => {
    const { name, value } = evt?.target
    const isSpot = value === "true"
    !!name && setTvSheetView(isSpot)
    update({ id, configScope, isSpot })
  }

  return (
    <div className={styles.container}>
      <h5 className={cx("BodyBody-1BlackBold", styles.title)}>
        {`${t("mba.config.campaign.tv.view")}: `}
      </h5>
      <div>
        <RadioGroup
          className={styles.radioGroup}
          aria-label="Set Tv Sheet Display View"
          name="tvSheetView"
          value={tvSheetView !== undefined ? tvSheetView : false}
          onChange={handleTvViewSelection}
        >
          <FormControlLabel
            value={true}
            label={"Spot"}
            control={<Radio color="primary" />}
            disabled={disabled}
          />
          <FormControlLabel
            value={false}
            label={"Line item"}
            control={<Radio color="primary" />}
            disabled={disabled}
          />
        </RadioGroup>
      </div>
    </div>
  )
}

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  `,
  title: css`
    margin-bottom: var(--spacing-s);
  `,
  disabled: css`
    color: var(--grey);
  `,
  radioGroup: css`
    display: flex;
    flex-direction: row;
    column-gap: 2rem;
  `,
}
